import { render, staticRenderFns } from "./MarketingCreditsList.vue?vue&type=template&id=b0ee92fa&scoped=true"
import script from "./MarketingCreditsList.vue?vue&type=script&lang=js"
export * from "./MarketingCreditsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ee92fa",
  null
  
)

export default component.exports